<template>
    <div class="hours-overview">
        <div class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <strong class="navbar-brand">Filters:</strong>
                <ul class="navbar-nav nav-pills me-auto mb-2 mb-lg-0 rounded-2">
                    <li class="nav-item dropdown">
                        <a class="nav-link fw-bold dropdown-toggle" href="#" role="button"
                           :class="{'active': (selectedUsers.length > 0 || selectedRoles.length > 0)}"
                           data-bs-toggle="dropdown">
                            <i class="las la-user"></i>
                            Gebruiker
                            <span class="badge bg-secondary"
                                  v-if="this.selectedUsers.length > 0">{{ this.selectedUsers.length }}</span>
                        </a>

                        <div class="dropdown-menu p-4">
                            <input type="search" id="userSearch" class="form-control" v-model="userSearch"
                                   placeholder="Gebruiker of rol zoeken..."/>

                            <div class="mb-3 mt-3">
                                <div class="d-flex align-items-center width-100">
                                    <strong>Rollen</strong>
                                    <div class="d-flex gap-2" style="margin-left: auto;">
                                        <button class="btn btn-link p-0" @click="selectAllRoles()">alles</button>
                                        <button class="btn btn-link p-0" @click="selectNoRoles()">niets</button>
                                    </div>
                                </div>
                                <ul class="list-group mt-2" v-if="roles.length > 0 && users.length > 0">
                                    <li class="list-group-item d-flex gap-2" v-for="role in roles" :key="role.id"
                                        :class="{'active': selectedRoles.includes(role.id)}">
                                        <input type="checkbox" :id="role.id" :value="role.id" v-model="selectedRoles">
                                        <label :for="role.id">{{ role.name }}</label>
                                    </li>
                                </ul>

                                <div class="alert alert-info" v-if="roles.length == 0 || users.length == 0">
                                    Bezig met laden...
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="d-flex align-items-center width-100">
                                    <strong>Gebruikers</strong>
                                    <div class="d-flex gap-2" style="margin-left: auto;">
                                        <button class="btn btn-link p-0" @click="selectAllUsers()">alles</button>
                                        <button class="btn btn-link p-0" @click="selectNoUsers()">niets</button>
                                    </div>
                                </div>
                                <ul class="list-group mt-2" v-if="roles.length > 0 && users.length > 0">
                                    <li class="list-group-item d-flex gap-2" v-for="user in users" :key="user.id"
                                        :class="{'active': selectedUsers.includes(user.id)}">
                                        <input type="checkbox" :id="user.id" :value="user.id" v-model="selectedUsers">
                                        <label :for="user.id">{{ user.name }}</label>
                                    </li>
                                </ul>

                                <div class="alert alert-info" v-if="roles.length == 0 || users.length == 0">
                                    Bezig met laden...
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">
                            <i class="las la-users"></i>
                            Klant
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">
                            <i class="las la-folder"></i>
                            Project
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">
                            <i class="las wallet"></i>
                            Billable
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#">
                            <i class="las la-comment-dots"></i>
                            Omschrijving
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import axios from 'axios'
import Tooltip from 'bootstrap/js/src/tooltip'

export default {
    components: {
        Tooltip,
        Multiselect
    },
    data() {
        return {
            roles: [],
            userSearch: null,
            users: [],
            selectedUsers: [],
            selectedRoles: [],
            selectedRoleNames: []
        }
    },
    watch: {
        selectedRoles: {
            handler: function (val, oldVal) {
                this.selectedRolesUpdated()
            },
        }
    },
    computed: {},
    methods: {
        selectAllRoles() {
            this.selectedRoles = []

            this.roles.forEach(role => {
                this.selectedRoles.push(role.id)
            })
        },
        selectNoRoles() {
            this.selectedRoles = []
            this.selectedUsers = []
        },
        selectAllUsers() {
            this.selectedUsers = []
            this.users.forEach(user => {
                this.selectedUsers.push(user.id)
            })
        },
        selectNoUsers() {
            this.selectedUsers = []
            this.selectedUsers = []
        },
        selectedRolesUpdated(r) {
            this.selectedUsers = []
            this.selectedRoleNames = []

            if (this.selectedRoles.length > 0) {
                this.selectedRoleNames = this.selectedRoles.map(role => {
                    return this.roles.find(r => r.id === role).name
                })

                this.users.forEach(user => {
                    if (this.selectedRoleNames.includes(user.role)) {
                        this.selectedUsers.push(user.id)
                    }
                })
            }
        },
        fetchUsers() {
            axios.get('/api/users')
                .then(response => {
                    this.users = response.data
                })
                .catch(error => {
                })
        },
        fetchRoles() {
            axios.get('/api/roles')
                .then(response => {
                    this.roles = response.data
                })
                .catch(error => {
                })
        },
    },
    mounted() {
        this.emitter.emit('hide-breadcrumbs');
        this.emitter.emit('set-title', 'Urenoverzicht')
        this.emitter.emit('set-breadcrumbs', [
            {
                label: 'Overzicht',
                url: '/texts/overview'
            }
        ])

        this.fetchUsers()
        this.fetchRoles()
    }
}
</script>

<style>
.navbar {
    background: var(--bs-gray-50);
    border-radius: .25rem;

    .navbar-nav {
        gap: 1.25rem
    }
}

div.dropdown-menu {
    min-width: 40ch;
    max-width: 70ch;
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
